import type { TFunction } from "i18next";
import { Base } from "../../../framework/base";
import { PlannedWorkShiftDto } from "../../../models/plannedWorkShift/plannedWorkShift";

export const buildOverlapTooltip = (
    conflictIds: string[],
    allShifts: PlannedWorkShiftDto[],
    t: TFunction
): string | null => {
    if (!conflictIds || conflictIds.length === 0) return null;

    const conflicts = conflictIds
        .map((id) => allShifts.find((s) => s.id === id))
        .filter((s) => !!s)
        .sort((a, b) => Base.dayjsCompare?.(a.startTime, b.startTime) ?? (a.startTime < b.startTime ? -1 : 1));

    const lines = conflicts.map((c) => {
        const sameDay = Base.isSameDay(c.startTime, c.endTime);
        const startStr = Base.dayjsToTimeStr(c.startTime);
        const endStr = sameDay ? Base.dayjsToTimeStr(c.endTime) : Base.dayjsToShortDateTimeStr(c.endTime);
        const name = (c.label || "").trim();
        return `${startStr} - ${endStr}${name ? ` (${name})` : ""}`;
    });

    const header = conflicts.length === 1
        ? t("workShiftPlanning.overlap.single")
        : t("workShiftPlanning.overlap.multiple");

    return [header, ...lines].join("\n");
};

export const tooltipProps = {
    enterDelay: 700,
    enterNextDelay: 200,
    leaveDelay: 0,
    enterTouchDelay: 800,
    leaveTouchDelay: 0,
    disableInteractive: true,
    arrow: true,
    describeChild: true,
};